"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var React = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../../components/Common/Box"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  font-size: ", "px;\n  color: ", ";\n\n  :before {\n    font-family: ", " !important;\n    font-style: normal;\n    font-weight: normal !important;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconWrap = (0, _styledComponents["default"])(_Box["default"])(_templateObject(), function (_ref) {
  var _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 24 : _ref$fontSize;
  return fontSize;
}, function (_ref2) {
  var _ref2$fontSize = _ref2.fontSize,
      fontSize = _ref2$fontSize === void 0 ? 24 : _ref2$fontSize;
  return fontSize;
}, function (_ref3) {
  var _ref3$fontSize = _ref3.fontSize,
      fontSize = _ref3$fontSize === void 0 ? 24 : _ref3$fontSize;
  return fontSize;
}, function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var fontName = _ref5.fontName;
  return fontName;
});

var Icon = function Icon(_ref6) {
  var name = _ref6.name,
      category = _ref6.category,
      size = _ref6.size,
      color = _ref6.color,
      onClick = _ref6.onClick,
      style = _ref6.style;
  return /*#__PURE__*/React.createElement(IconWrap, {
    className: "icon-".concat(category.replace(/ /g, '-'), "-").concat(name),
    color: color,
    fontSize: size,
    fontName: category,
    onClick: onClick,
    style: style
  });
};

var _default = Icon;
exports["default"] = _default;